import React from "react";
import ReactDOM from "react-dom/client";
import { initAnalytics } from "./firebase.js";
import App from "./App.jsx";

const root = document.getElementById("root");

function showStatus(msg) {
  root.innerHTML = `
    <div style="display:flex;flex-direction:column;align-items:center;justify-content:center;
                min-height:100vh;background:#060a06;
                font-family:'Segoe UI',sans-serif;padding:20px;text-align:center;">
      <div style="font-family:'Barlow Condensed',sans-serif;font-weight:900;font-size:28px;
                  letter-spacing:0.3px;color:#fff;margin-bottom:20px">FootL<span style="display:inline-block;
                  width:1ex;height:1ex;border-radius:50%;background:#00ff88;margin:0 0.03em;
                  vertical-align:baseline"></span>g</div>
      <div style="font-size:12px;color:#607060;max-width:300px;line-height:1.6">${msg}</div>
    </div>
  `;
}

class ErrorBoundary extends React.Component {
  constructor(props) { super(props); this.state = { error: null }; }
  static getDerivedStateFromError(e) { return { error: e }; }
  componentDidCatch(e, info) { console.error("[FL] Render crash:", e, info); }
  render() {
    if (this.state.error) {
      return React.createElement("div", {
        style: { display:"flex", flexDirection:"column", alignItems:"center", justifyContent:"center",
                 minHeight:"100vh", background:"#060a06", color:"#e8f0e8",
                 fontFamily:"'Segoe UI',sans-serif", padding:"24px", textAlign:"center" }
      },
        React.createElement("div", { style: { fontFamily: "'Barlow Condensed',sans-serif", fontWeight: 900, fontSize: 28, letterSpacing: 0.3, color: "#fff", marginBottom: 12 } },
          "FootL",
          React.createElement("span", { style: { display: "inline-block", width: "1ex", height: "1ex", borderRadius: "50%", background: "#00ff88", margin: "0 0.03em", verticalAlign: "baseline" } }),
          "g"
        ),
        React.createElement("div", { style: { fontSize: 13, color: "#607060", marginBottom: 12, lineHeight: 1.6, maxWidth: 360 } },
          "Coś poszło nie tak. Odśwież stronę — jeśli problem się powtarza, wyczyść cache przeglądarki."
        ),
        React.createElement("div", { style: { fontSize: 10, color: "#ef4444", background: "#1a0a0a", borderRadius: 8, padding: "10px 14px", marginBottom: 20, maxWidth: 440, wordBreak: "break-all", textAlign: "left", fontFamily: "monospace", whiteSpace: "pre-wrap", overflow: "auto", maxHeight: 220 } },
          this.state.error?.stack || this.state.error?.message || String(this.state.error)
        ),
        React.createElement("button", {
          onClick: () => window.location.reload(),
          style: { background:"#00ff88", color:"#060a06", border:"none", borderRadius:10,
                   padding:"12px 28px", fontSize:15, fontWeight:700, cursor:"pointer", letterSpacing:1 }
        }, "Odśwież →")
      );
    }
    return this.props.children;
  }
}

function renderApp() {
  ReactDOM.createRoot(root).render(
    React.createElement(React.StrictMode, null,
      React.createElement(ErrorBoundary, null, React.createElement(App))
    )
  );
}

async function boot() {
  showStatus("Łączenie...");

  // Sprawdź wersję buildu — jeśli jest nowy deploy, wyczyść cache i przeładuj
  const BUILD = __APP_BUILD__;
  const storedBuild = localStorage.getItem("fl_build");
  if (storedBuild && storedBuild !== BUILD) {
    localStorage.setItem("fl_build", BUILD);
    // Wyczyść cache przeglądarki (Service Worker caches)
    if ("caches" in window) {
      const keys = await caches.keys();
      await Promise.all(keys.map(k => caches.delete(k)));
    }
    window.location.reload();
    return;
  }
  localStorage.setItem("fl_build", BUILD);

  // Tu stało czekanie na pierwsze zdarzenie onAuthStateChanged (z czterosekundowym
  // fallbackiem) PRZED zamontowaniem Reacta. Nie chroniło przed niczym, a kosztowało
  // cały pierwszy paint:
  //
  //  • useAuth ma własne onAuthStateChanged i własny `sessionRestoring`, który
  //    startuje na `true`. App renderuje wtedy splash, a formularz logowania
  //    wymaga `!sessionRestoring` — migotania loginu nie ma z konstrukcji.
  //  • Cały CSS siedzi w <style>{css}</style> wewnątrz App, więc do zamontowania
  //    Reacta na ekranie nie było NIC poza showStatus("Łączenie...") z góry tej
  //    funkcji — surowym HTML-em wklejonym w innerHTML.
  //  • Dla zalogowanego z wygasłym tokenem Firebase robi w tym miejscu sieciowe
  //    odświeżenie tokena. To był ten moment, w którym aplikacja „wolno się ładuje".
  //  • Fallback nie dawał odporności: `setSessionRestoring(false)` woła wyłącznie
  //    callback w useAuth, więc gdy auth milczało, splash i tak zostawał na zawsze.
  //    Bezpiecznik jest teraz tam, gdzie jedynie ma sens — w useAuth.
  renderApp();

  // Po pierwszym renderze, nie przed. Nie czekamy na wynik — Analytics nie jest
  // do niczego potrzebny do działania aplikacji.
  initAnalytics();
}

boot();
